import { PropsWithChildren, useMemo } from 'react';
import { AdminInviteUsersContext, AdminInviteUsersContextType } from './index';

export function AdminInviteUsersContextProvider(props: PropsWithChildren) {
  const value = useMemo<AdminInviteUsersContextType>(
    () => ({
      rows: [],
    }),
    [],
  );

  return (
    <AdminInviteUsersContext.Provider value={value}>
      {props.children}
    </AdminInviteUsersContext.Provider>
  );
}
